module.exports = __webpack_public_path__ + "static/media/ic_arrow.a98f1770.svg";